import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { NgxUiLoaderService } from 'ngx-ui-loader';
import { finalize, Observable } from 'rxjs';

@Injectable() 
export class ReqInterceptor implements HttpInterceptor {
 constructor(
  // private _ngxLoaderService: NgxUiLoaderService
  ){}
  private _ActiveRequests = 0

 intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //  console.log("Ingresando al interceptor");
   if (this._ActiveRequests === 0){
    // this._ngxLoaderService.start();
   }
   this._ActiveRequests++
   return next.handle(req).pipe(finalize(()=> {
    this.stopLoader()
   }));
 }

 private stopLoader(){
  this._ActiveRequests--;
  if(this._ActiveRequests === 0){
    // this._ngxLoaderService.stop()
  }
 }
}
